/**
 * 会员信息
 */
import React from 'react';
import messager from '../../ui/messager';
import { Input, Row, Col, Button, Icon, Tooltip} from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import MemberBankEdit from './MemberBankEdit';
import { global_data } from '../../ui/auth'


class MemberBankIndex extends React.Component {

    columns = [
    {
        title: '所属会员',
        dataIndex: 'memberName1',
        width: '10%',
    }
    , {
        title: '公司名称',
        dataIndex: 'memberName',
        width: '10%',
    }
    , {
        title: '证件号码',
        dataIndex: 'memberCreditNo',
        width: '10%',
    }
    , {
        title: '户名',
        dataIndex: 'payee',
        width: '5%',
    }
    , {
        title: '开户行',
        dataIndex: 'bankOfDeposit',
        width: '9%'
    }
    , {
        title: '账号',
        dataIndex: 'bankAccounts',
        width: '10%'
    }
    , {
        title: '联系电话',
        dataIndex: 'contactTel',
        width: '7%'
    }
    ,{
        title: '地址',
        dataIndex: 'memberAddress',
        width: '8%'
    }
    , {
        title: '创建时间',
        dataIndex: 'createTime',
        width: '7%',
    }
    ,{
        title: '操作',
        dataIndex: 'id',
        width: '8%',
        render: (text, record, index) => (
            <div>  
                {global_data.authCode.includes("MEMBER_BANK_UPDATE")?
                <Tooltip title="修改">
                    <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record)} />
                </Tooltip>
                :""}
                {global_data.authCode.includes("MEMBER_BANK_DELETE")?
                <Tooltip title="删除">
                    <Icon type="delete" theme="filled" className="table-operate-icon" onClick={this.delete.bind(this, text)} />
                </Tooltip>
                :""}
            </div>
        )
    }
];

    state = {
        loadData: '',
        queryData: {},
        loadingVisible: false,
        visible: false,
        editData: {}
    };

    add = () => {
        let editData=this.state;
        editData.accountDayNumber=0;
        editData.totalVehicleNumber=0;
        this.setState({ editData: editData, visible: true });
    }

    update = (info, e) => {
        this.setState({ editData: info, visible: true });
    }

    delete = (text, e) => {
        messager.confirm("是否删除该账户信息？", () => {
            http.get({
                url: "/memberBank/delete",
                data: { id: text },
                success: (res) => {
                    this.state.loadData(this.state.queryData);
                    messager.notify("删除成功！");
                }
            });
        });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.memberName = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    // selectChange = (value) => {
    //     let { queryData } = this.state;
    //     queryData["state"] = value;
    //     this.setState({ queryData: queryData });
    //     this.state.loadData(queryData);
    // }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="公司名等关键字"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: 400 }}
                                />
                                {/* <Select onChange={this.selectChange} allowClear={true} style={{ width: "150px", marginLeft: '10px' }}>
                                    <Select.Option value="">全部</Select.Option>
                                    <Select.Option value="1">启用</Select.Option>
                                    <Select.Option value="0">停用</Select.Option>
                                </Select> */}
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("MEMBER_BANK_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="id"
                    url="/memberBank/page"
                    columns={this.columns}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <MemberBankEdit
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false, editData: {} }) }}
                    editData={this.state.editData}
                    successCallback={this.state.loadData}
                    queryData={this.state.queryData}
                />
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </div>
        )
    }
}

export default MemberBankIndex;